<script setup lang="ts">
import {computed} from "vue";
import {useSubscriptionPlanStore} from "@/stores/subscription-plan.store";
import {storeToRefs} from "pinia";
import SubscriptionPlanService from "@/subscription-plan/services/SubscriptionPlanService";
import ApodisPremiumUnsubscribedView from "@/subscription-plan/views/ApodisPremiumUnsubscribedView.vue";
import ApodisPremiumSubscribedView from "@/subscription-plan/views/ApodisPremiumSubscribedView.vue";
import useApodisPremiumContentful from "@/subscription-plan/composables/useApodisPremiumContentful";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";

const {globalPlan} = storeToRefs(useSubscriptionPlanStore());
const {data, isLoading} = useApodisPremiumContentful();

/**
 * Determine if the user has an active subscription for the global plan.
 */
const hasActiveSubscription = computed(() => {
    if (!globalPlan.value) {
        return false;
    }

    return SubscriptionPlanService.hasActiveSubscription(globalPlan.value);
});
</script>

<template>
  <div v-if="isLoading || !data" class="min-h-full gradient">
    <BaseFlexSpinner />
  </div>
  <template v-else>
    <ApodisPremiumUnsubscribedView v-if="!hasActiveSubscription" :data="data" />
    <ApodisPremiumSubscribedView v-else :data="data" />
  </template>
</template>
